import React from 'react';

import {CheckBox} from '@pb/kit-component-checkbox';
import {SlideBoxButton} from '@pb/kit-component-slide-box';

type Props = {
    index: number,
    expanded: boolean,
    onToggle: (index: number) => void,
};

export const SlideButton = (props: Props) => {
    const {
        index,
        expanded,
        onToggle,
    } = props;

    const onClick = () => {
        onToggle(index);
    };

    return (
        <SlideBoxButton onClick={onClick}>
            {toggleSlideBox => (
                <CheckBox
                    name="default"
                    onCheckBoxChange={toggleSlideBox}
                    checked={expanded}
                    custom={true}
                    usePropsOnly={true}
                />
            )}
        </SlideBoxButton>
    );
};
